"use client";

import { Sun } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Inquiry() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="164" id="service-inquiry" className="relative overflow-hidden bg-background text-foreground py-24 md:py-[140px]">
      {}
      <svg className="pointer-events-none absolute top-8 left-8 h-32 w-32 opacity-10 md:h-48 md:w-48" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M20 180 Q 40 120 80 100 T 160 40" stroke="hsl(0 0% 5%)" strokeWidth="1" fill="none" />
        <path d="M30 170 Q 60 140 70 110" stroke="hsl(0 0% 5%)" strokeWidth="1" fill="none" />
        <path d="M90 95 Q 100 80 110 70 Q 120 65 130 70" stroke="hsl(0 0% 5%)" strokeWidth="1" fill="none" />
        <circle cx="80" cy="100" r="3" fill="hsl(0 0% 5%)" />
        <circle cx="130" cy="70" r="2.5" fill="hsl(0 0% 5%)" />
      </svg>
      <svg className="pointer-events-none absolute bottom-8 right-8 h-32 w-32 opacity-10 md:h-48 md:w-48 rotate-180" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M20 180 Q 40 120 80 100 T 160 40" stroke="hsl(0 0% 5%)" strokeWidth="1" fill="none" />
        <path d="M30 170 Q 60 140 70 110" stroke="hsl(0 0% 5%)" strokeWidth="1" fill="none" />
        <path d="M90 95 Q 100 80 110 70 Q 120 65 130 70" stroke="hsl(0 0% 5%)" strokeWidth="1" fill="none" />
        <circle cx="80" cy="100" r="3" fill="hsl(0 0% 5%)" />
        <circle cx="130" cy="70" r="2.5" fill="hsl(0 0% 5%)" />
      </svg>

      <div ref={ref} className={`relative mx-auto max-w-[720px] px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="mb-8 flex justify-center">
          <Sun className="h-10 w-10 text-[hsl(21,82%,51%)]" strokeWidth={1.25} aria-hidden="true" />
        </div>

        {}
        <div className="mb-8 flex items-center justify-center gap-4">
          <span className="block h-px w-[60px]" style={{
          backgroundColor: "hsl(21, 82%, 51%)"
        }} aria-hidden="true" />
          <span className="font-default text-xs uppercase tracking-[0.25em]" style={{
          color: "hsl(0, 0%, 45%)"
        }}>
            Discover Your 5ONDER Score
          </span>
          <span className="block h-px w-[60px]" style={{
          backgroundColor: "hsl(21, 82%, 51%)"
        }} aria-hidden="true" />
        </div>

        {}
        <h2 className="font-default font-medium leading-[0.9] text-foreground text-4xl md:text-6xl" style={{
        letterSpacing: "0.15em"
      }}>
          You built something real. Does the internet know it exists?
        </h2>

        {}
        <p className="mx-auto mt-8 max-w-[600px] font-default text-lg" style={{
        color: "hsl(0, 0%, 45%)",
        lineHeight: 1.6
      }}>
          Get found. Get heard. Get trusted. Let's define your brand's true potential.
        </p>

        {}
        <div className="mt-10 flex flex-col items-stretch justify-center gap-4 sm:flex-row sm:items-center sm:gap-4">
          <Button asChild size="lg" className="h-14 bg-[hsl(21,82%,51%)] px-8 font-default text-sm font-medium uppercase tracking-[0.15em] text-white hover:opacity-90">
            <Link to="/ContactPage">Discover Your 5ONDER Score</Link>
          </Button>
        </div>

        {}
        <p className="mt-8 font-default text-xs tracking-[0.15em]" style={{
        color: "hsl(0, 0%, 45%)"
      }}>
          No commitment. Direct consultation.
        </p>
      </div>
    </section>;
}